export enum EntityTable {
    TblActivity = 'TblActivity',
    TblAtc = 'TblAtc',
    TblBankAccount = 'TblBankAccount',
    TblBenefit = 'TblBenefit',
    TblCase = 'TblCase',
    TblCodingSchema = 'TblCodingSchema',
    TblDiagnosis = 'TblDiagnosis',
    TblDrugInteraction = 'TblDrugInteraction',
    TblDrugManagementPlan = 'TblDrugManagementPlan',
    TblDrugInteractionCategory = 'TblDrugInteractionCategory',
    TblEmail = 'TblEmail',
    TblGrandfather = 'TblGrandfather',
    TblIngredient = 'TblIngredient',
    TblInsuredPerson = 'TblInsuredPerson',
    TblIssueTicket = 'TblIssueTicket',
    TblLimit = 'TblLimit',
    TblLocation = 'TblLocation',
    TblMasterDrug = 'TblMasterDrug',
    TblManufacturer = 'TblManufacturer',
    TblMessage = 'TblMessage',
    TblNationalDrug = 'TblNationalDrug',
    TblNationalDrugFormulary = 'TblNationalDrugFormulary',
    TblPayer = 'TblPayer',
    TblPayment = 'TblPayment',
    TblPolicy = 'TblPolicy',
    TblPolicyProductPerson = 'TblPolicyProductPerson',
    TblProduct = 'TblProduct',
    TblProvider = 'TblProvider',
    TblProviderGroup = 'TblProviderGroup',
    TblProviderNetwork = 'TblProviderNetwork',
    TblProviderSpeciality = 'TblProviderSpeciality',
    TblRefill = 'TblRefill',
    TblRulesEngineMetadata = 'TblRulesEngineMetadata',
    TblSms = 'TblSms',
    TblTransaction = 'TblTransaction',
    TblUser = 'TblUser',
    TblApplication = 'TblApplication',
    TblBroker = 'TblBroker'
}
